import tw, { css, styled } from 'twin.macro';
import isPropValid from '@emotion/is-prop-valid';

interface Props {
  dashedBorder?: boolean;
}

export const AteliersStyleWrapper = styled('div', {
  shouldForwardProp: prop => isPropValid(prop),
})<Props>(({ dashedBorder = true }) => [
  tw`flex flex-col`,
  css`
    clear: both;
    &:has(> *) {
      ${dashedBorder &&
      tw`border border-neutral-moderate rounded-lg border-dashed`}
    }

    &:not(:has(> *)) {
      ${tw`hidden`}
    }

    .atelier-card:not(:last-child) {
      ${tw`border-b border-neutral-moderate border-dashed`}
    }
  `,
]);
